import { call, put, takeLatest } from 'redux-saga/effects';
import {
  FETCH_ACCOUNT_STATUS_REQUEST,
} from './constants';
import {
  fetchAccountStatusSuccess,
  fetchAccountStatusFailure,
} from './actions';
import { fetchAccountStatusList } from './service';

function* handleFetchAccountStatus(action: any): any {
  try {
    const { module, ...params } = action.payload;
    const response = yield call(fetchAccountStatusList, module, params);

    const data = response.data.data.document;
    const total = response.data.data.meta?.total ?? data.length; // fallback if meta is missing

    yield put(fetchAccountStatusSuccess({
      data,
      meta: { total }
    }));
  } catch (error: any) {
    console.error('❌ FETCH ERROR:', error);
    yield put(fetchAccountStatusFailure(error.message));
  }
}

export function* saga() {
  yield takeLatest(FETCH_ACCOUNT_STATUS_REQUEST, handleFetchAccountStatus);
}
